import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Layout,
  Link,
  PageHeader,
  Section,
  Spacer,
  Text,
} from '../../components/shared';

export const ConsentRequestedPresenter: React.VFC = () => {
  const { t } = useTranslation();

  return (
    <Layout
      activeNavigationItem="home"
      header={<PageHeader title={t('ui.pages.ConsentRequested.title')} />}
      showNavigator
    >
      <div css={{ padding: 16 }}>
        <Section>
          <Text>{t('ui.pages.ConsentRequested.message')}</Text>
          <Spacer space={32} />
          <div css={{ display: 'flex' }}>
            <Text>※</Text>
            <Text>{t('ui.pages.ConsentRequested.annotation')}</Text>
          </div>
        </Section>
        <Spacer space={32} />
        <div
          css={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Link bold color="textPrimary" to="/">
            {t('global.backToTop')}
          </Link>
        </div>
      </div>
    </Layout>
  );
};
